/**
 * Mbp module definition — passive publisher ad analytics (GPT + Prebid + Voltax
 * observation, revenue prediction events).
 * Host opt-in only: activates via `init({ mbp: true })` or the `data-kz-mbp`
 * script attribute.
 */

import type { SdkModuleDefinition } from '../types';
import { createMbpModuleApi, type MbpModuleApi } from './api';

export const mbpModule: SdkModuleDefinition<MbpModuleApi> = {
  id: 'mbp',
  isEnabled: (_config, options) => options.mbp,
  install: (ctx) => createMbpModuleApi(ctx),
};
